import React from 'react'
import {Route, IndexRoute} from 'react-router'
import Layout from './Layout'
import Main from './Main'
import Create from './Create'
import Prepare from './Prepare'
import PrepareTemplate from './PrepareTemplate'
import Document from './Document'
// import Verification from './Verification'

export default (
  <Route path="/sign" component={Layout}>
    <IndexRoute component={Main} />
    <Route path="me" component={Create} />
    <Route path="others" component={Create} />
    <Route path="prepare/:documentId" component={Prepare} />
    <Route path="prepare/template/:templateId" component={PrepareTemplate} />
    <Route path=":documentId" component={Document} />
    <Route path=":documentId/verify-email/:token" component={Document} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/index.js